export default __webpack_public_path__ + "static/media/expl_03_EN.5ee09455.png";